import { Component, OnInit } from '@angular/core'
import { MainService } from '../../service/main.service'

@Component({
	selector: 'gw-banner',
	templateUrl: './banner.component.html',
	styleUrls: ['../comment.component.styl']
})

export class BannerComponent implements OnInit{
	banner_title1: string;
	banner_title2: string;
	banner_summay: string;
	constructor(public mainService: MainService) {
		
	}
	ngOnInit() {
		this.mainService.getCommentData()
		.subscribe(
			data=>{
				this.banner_title1 = data.banner_title1;
				this.banner_title2 = data.banner_title2;
				this.banner_summay = data.banner_summay;
			},
			error=>{
				console.log(error)
			}
		)
	}
}


// WEBPACK FOOTER //
// C:/Users/Administrator/submit text project/gwin/src/app/comment/banner/banner.component.ts